import type { SxProps, Theme } from '@mui/material';

export const styles = {
    wrapper: (filled: boolean, required: boolean, theme: Theme): SxProps<Theme> => {
        const showRequiredEmpty = required && !filled;
        const bg = filled ? theme.palette.blue[30] : 'transparent';
        const accent = showRequiredEmpty ? theme.palette.red.main : undefined;
        return {
            '& .MuiFilledInput-root': {
                backgroundColor: bg,
                transition: 'background-color 0.15s ease',
                '&:hover': { backgroundColor: bg },
                '&.Mui-focused': { backgroundColor: bg },
                '&.Mui-disabled, &.Mui-disabled:hover, &.Mui-disabled.Mui-focused': {
                    backgroundColor: theme.palette.grey[40],
                },
                ...(accent && {
                    '&:before': { borderBottomColor: accent },
                    '&:hover:not(.Mui-disabled):before': { borderBottomColor: accent },
                    '&:not(.Mui-focused) .MuiAutocomplete-popupIndicator .MuiSvgIcon-root': {
                        color: accent,
                    },
                }),
            },
            ...(accent && {
                '& .MuiInputLabel-root:not(.Mui-focused)': { color: accent },
            }),
            '& .MuiFormControl-root, & .MuiAutocomplete-root': {
                width: '100%',
                margin: 0,
            },
        };
    },
};
